import { DELETE_EVENT_MUTATION } from "@graphql"
import { useMutation } from "@apollo/client"

const useDeleteEvent = () => {
  const [deleteEvent, {data, loading, error}] = useMutation(DELETE_EVENT_MUTATION, {
    update: (cache, { data, variables }) => {
      const id = data?.deleteEvent?.id ?? variables?.id;
          
      if (data?.deleteEvent?.success && id) {
        const cacheId = cache.identify({ __typename: "Event", id });
        
        if (cacheId) {
          cache.evict({ id: cacheId });
          cache.gc();
        }
      }
    }
  })

  return {
    deleteEvent,
    data,
    loading,
    error,
  }
}

export default useDeleteEvent